import http from "@/api/http";
import crypto from "@/lib/crypto";

const PREFIX = '/user'
const IS_MOCK = process.env.VUE_APP_IS_MOCK == 'true'

function getBaseInfoById(userId, mode){
    const token = crypto.SHA256("SHA"+mode+userId);
    const url = `${PREFIX}/${userId}`;
    if (!IS_MOCK) {
        return http.get(url, {t:token});
    } else {
        const mockReponse = {
            "data" : {}
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function getBaseInfoByUuid(uuid, mode){
    const token = crypto.SHA256("SHA"+mode+uuid);
    const url = `${PREFIX}/${uuid}/byUuid`;
    if (!IS_MOCK) {
        return http.get(url, {t:token});
    } else {
        const mockReponse = {
            "data" : {}
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function getBaseInfoByUserNo(userNo, mode){
    const token = crypto.SHA256("SHA"+mode+userNo);
    const url = `${PREFIX}/${userNo}/byUserNo`;
    if (!IS_MOCK) {
        return http.get(url, {t:token});
    } else {
        const mockReponse = {
            "data" : {}
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function getBaseInfoByIdAuthority(userId, authority, mode){
    const token = crypto.SHA256("SHA"+mode+userId);
    let url = `${PREFIX}/${userId}`;
    if(authority == 0 || authority == 10) {
        url = url + "/admin";
    }
    if (!IS_MOCK) {
        return http.get(url, {t:token});
    } else {
        const mockReponse = {
            "data" : {}
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function postUserInfo(param){
    const url = `${PREFIX}`;
    if (!IS_MOCK) {
        return http.post(url, param);
    } else {
        const mockReponse = {
            "data" : {}
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function putUserPwd(userId, orgPassword, newPassword){
    const url = `${PREFIX}/${userId}/password`;
    if (!IS_MOCK) {
        return http.put(url, {
            orgPassword : crypto.SHA256(orgPassword),
            newPassword : crypto.SHA256(newPassword)
        });
    } else {
        const mockReponse = {
            "data" : {}
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function putBaseInfo(userId, param){
    const url = `${PREFIX}/${userId}`;
    if (!IS_MOCK) {
        return http.put(url, param);
    } else {
        const mockReponse = {
            "data" : {}
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function getReadableUserList(param){
    const url = `${PREFIX}/readable/list`;
    if (!IS_MOCK) {
        return http.get(url, param);
    } else {
        const mockReponse = {totalCount: 5, list: [{insertId: null, createDateTime: "2020-01-23, 04:02", updateDateTime: null,id: "scla000201v",pw: null,name: "톰조회계정",phoneNumber: "01011112222",extentionNumber: "123",authority: 0,useYn: null,schoolUuid: null,schoolNm: null,post: null,address1: null,address2: null,type: null,insertNm: "톰2",totalCount: 11},
        {insertId: null, createDateTime: "2020-01-23, 04:02", updateDateTime: null,id: "scla000202v",pw: null,name: "톰조회계정1",phoneNumber: "01011112222",extentionNumber: "123",authority: 0,useYn: null,schoolUuid: null,schoolNm: null,post: null,address1: null,address2: null,type: null,insertNm: "톰2",totalCount: 11}
        ,{insertId: null, createDateTime: "2020-01-23, 04:02", updateDateTime: null,id: "scla000203v",pw: null,name: "톰조회계정2",phoneNumber: "01011112222",extentionNumber: "123",authority: 0,useYn: null,schoolUuid: null,schoolNm: null,post: null,address1: null,address2: null,type: null,insertNm: "톰2",totalCount: 11}
        ,{insertId: null, createDateTime: "2020-01-23, 04:02", updateDateTime: null,id: "scla000204v",pw: null,name: "톰조회계정3",phoneNumber: "01011112222",extentionNumber: "123",authority: 0,useYn: null,schoolUuid: null,schoolNm: null,post: null,address1: null,address2: null,type: null,insertNm: "톰2",totalCount: 11}
        ,{insertId: null, createDateTime: "2020-01-23, 04:02", updateDateTime: null,id: "scla000205v",pw: null,name: "톰조회계정4",phoneNumber: "01011112222",extentionNumber: "123",authority: 0,useYn: null,schoolUuid: null,schoolNm: null,post: null,address1: null,address2: null,type: null,insertNm: "톰2",totalCount: 11}]}
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function deleteUserById(userId){
    const url = `${PREFIX}/${userId}`;
    if (!IS_MOCK) {
        return http.delete(url);
    } else {
        const mockReponse = {
            "result" : 0
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

function putUserPasswordInit(userId, email){
    const url = `${PREFIX}/${userId}/${email}/pwd/init`;
    if (!IS_MOCK) {
        return http.put(url);
    } else {
        const mockReponse = {
            "result" : 0,
            "pwd" : 1234
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

//211005
function putLoginAttemptInit(userId){
    const url = `${PREFIX}/${userId}/loginAttempt/init`;
    if (!IS_MOCK) {
        return http.put(url);
    } else {
        const mockReponse = {
            "result" : 0,
            "pwd" : 1234
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

/** 관리자메뉴 > 담당자 리스트 조회
 * @param {String} searchValue 검색할 학교명
 * @param {*} page Page 정보 Object
 */
function getManageUserList(param){
    const url = `${PREFIX}/manage/list`;
    if (!IS_MOCK) {
        return http.get(url, param);
    } else {
        const mockReponse = {
            "totalCount":11,
            "list":[{"insertId":null,"createDateTime":"2020-01-22T19:02:41Z","updateDateTime":null,"userNo":0,"id":"scla000201v","pw":null,"name":"톰조회계정","phoneNumber":"01011112222","extentionNumber":"123","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:33:01Z","updateDateTime":null,"userNo":0,"id":"scla000302v","pw":null,"name":"조회계정톰2","phoneNumber":"01011112222","extentionNumber":"1231","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:36:56Z","updateDateTime":null,"userNo":0,"id":"scla000303v","pw":null,"name":"조회계정톰3","phoneNumber":"01011112222","extentionNumber":"123","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:37:11Z","updateDateTime":null,"userNo":0,"id":"scla000304v","pw":null,"name":"조회계정톰3","phoneNumber":"01011112222","extentionNumber":"123","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:38:48Z","updateDateTime":null,"userNo":0,"id":"scla000306v","pw":null,"name":"조회계정톰5","phoneNumber":"01011112222","extentionNumber":"1011","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:39:28Z","updateDateTime":null,"userNo":0,"id":"scla000307v","pw":null,"name":"조회계정톰11","phoneNumber":"01022221212","extentionNumber":"11","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:40:04Z","updateDateTime":null,"userNo":0,"id":"scla000308v","pw":null,"name":"조회계정톰66","phoneNumber":"01022221122","extentionNumber":"13","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-23T01:42:55Z","updateDateTime":null,"userNo":0,"id":"scla000407v","pw":null,"name":"톰계정","phoneNumber":"01011112222","extentionNumber":"13","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-23T01:43:18Z","updateDateTime":null,"userNo":0,"id":"scla000408v","pw":null,"name":"톰페이지","phoneNumber":"010-0101-2233","extentionNumber":"111","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-23T01:43:36Z","updateDateTime":null,"userNo":0,"id":"scla000409v","pw":null,"name":"랭크안된다","phoneNumber":"010-1124-6213","extentionNumber":"112","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11}]
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}
function getSiteManagerList(param){
    const url = `${PREFIX}/sitemanage/list`;
    if (!IS_MOCK) {
        return http.get(url, param);
    } else {
        const mockReponse = {
            "totalCount":11,
            "list":[{"insertId":null,"createDateTime":"2020-01-22T19:02:41Z","updateDateTime":null,"userNo":0,"id":"scla000201v","pw":null,"name":"톰조회계정","phoneNumber":"01011112222","extentionNumber":"123","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:33:01Z","updateDateTime":null,"userNo":0,"id":"scla000302v","pw":null,"name":"조회계정톰2","phoneNumber":"01011112222","extentionNumber":"1231","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:36:56Z","updateDateTime":null,"userNo":0,"id":"scla000303v","pw":null,"name":"조회계정톰3","phoneNumber":"01011112222","extentionNumber":"123","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:37:11Z","updateDateTime":null,"userNo":0,"id":"scla000304v","pw":null,"name":"조회계정톰3","phoneNumber":"01011112222","extentionNumber":"123","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:38:48Z","updateDateTime":null,"userNo":0,"id":"scla000306v","pw":null,"name":"조회계정톰5","phoneNumber":"01011112222","extentionNumber":"1011","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:39:28Z","updateDateTime":null,"userNo":0,"id":"scla000307v","pw":null,"name":"조회계정톰11","phoneNumber":"01022221212","extentionNumber":"11","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-22T21:40:04Z","updateDateTime":null,"userNo":0,"id":"scla000308v","pw":null,"name":"조회계정톰66","phoneNumber":"01022221122","extentionNumber":"13","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-23T01:42:55Z","updateDateTime":null,"userNo":0,"id":"scla000407v","pw":null,"name":"톰계정","phoneNumber":"01011112222","extentionNumber":"13","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-23T01:43:18Z","updateDateTime":null,"userNo":0,"id":"scla000408v","pw":null,"name":"톰페이지","phoneNumber":"010-0101-2233","extentionNumber":"111","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11},{"insertId":null,"createDateTime":"2020-01-23T01:43:36Z","updateDateTime":null,"userNo":0,"id":"scla000409v","pw":null,"name":"랭크안된다","phoneNumber":"010-1124-6213","extentionNumber":"112","authority":0,"useYn":null,"schoolUuid":null,"schoolNm":"돌마초등학교","post":null,"address1":null,"address2":null,"type":null,"insertNm":"톰2","totalCount":11}]
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

/** 관리자메뉴 > 담당자 userNo에 해당하는 담당자  상제 조회 
 * @param {number} userNo 사용자No
 */
function getManageUser(userNo){
    const url = `${PREFIX}/manage/${userNo}`;
    if (!IS_MOCK) {
        return http.get(url);
    } else {
        const mockReponse = {
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}
//220611
function getSiteManager(userNo){
    const url = `${PREFIX}/sitemanage/${userNo}`;
    if (!IS_MOCK) {
        return http.get(url);
    } else {
        const mockReponse = {
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(mockReponse);
            }, 100);
        });
    }
}

/** 관리자메뉴 > 담당자 등록 
 * @param {*} param 등록할 담당자 정보 
 */
function createManageUser(param){
    const url = `${PREFIX}/manage`;
    return http.post(url, param);
}
function createSiteManager(param){
    const url = `${PREFIX}/sitemanage`;
    return http.post(url, param);
}
/** 관리자메뉴 > 담당자 수정 
 * param {*} param 수정 할 담당자 정보 
 */
function updateManageUser(param){
    const url = `${PREFIX}/manage`;
    return http.put(url, param);
}
function updateSiteManager(param){
    const url = `${PREFIX}/sitemanage`;
    return http.put(url, param);
}

/** 관리자메뉴 > 담당자 비밀번호 초기화 
 * @param {number} userNo 사용자No
 */
function resetUserPw(userNo, email){
    const url = `${PREFIX}/manage/reset/${userNo}/${email}`;
    return http.put(url);
}
function resetSiteManagerPw(userNo, email){
    const url = `${PREFIX}/sitemanage/reset/${userNo}/${email}`;
    return http.put(url);
}

//220305
function resetAdminPw(userNo, userEmail){
    const url = `${PREFIX}/${userNo}/admin`;
    return http.put(url, {
        userId : userNo,
        userEmail : userEmail
    });
}

//211005
function resetUserLoginAttempt(userNo){
    const url = `${PREFIX}/manage/resetLoginAttempt/${userNo}`;
    return http.put(url);
}
function resetSiteManagerLoginAttempt(userNo){
    const url = `${PREFIX}/sitemanage/resetLoginAttempt/${userNo}`;
    return http.put(url);
}

function markedUserClass(uuid, userId, classNo){
    const url = `${PREFIX}/marked/${uuid}/${userId}/${classNo}`;
    if(!IS_MOCK) {
        return http.put(url);
    }
}

export default {
    getBaseInfoById,
    getBaseInfoByUuid,
    getBaseInfoByUserNo,
    getBaseInfoByIdAuthority,
    putUserPwd,
    putBaseInfo,
    postUserInfo,
    getReadableUserList,
    deleteUserById,
    putUserPasswordInit,
    putLoginAttemptInit, //211005
    getManageUserList,
    getSiteManagerList,
    getManageUser,
    getSiteManager,
    createManageUser,
    createSiteManager,
    updateManageUser,
    updateSiteManager,
    resetUserPw,
    resetSiteManagerPw,
    resetAdminPw, //220305
    resetUserLoginAttempt, //211005
    resetSiteManagerLoginAttempt,
    markedUserClass
};